'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeProvider = require('@spp/theme-provider');

var _Salesposter = require('./Salesposter');

var _Salesposter2 = _interopRequireDefault(_Salesposter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeProvider.themer)('@vg/salesposter')(_Salesposter2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/salesposter/lib/cjs/index.js
 ** module id = 741
 ** module chunks = 1
 **/